/**
 * F12 Sprint E — Studio Copilot Service (item #327)
 *
 * Client-side wrapper for the /api/ai/copilot endpoints.
 */

import { api } from './api.js';
import type { ApiResponse } from '@elmes/shared';

export interface CopilotToolCall {
  tool: string;
  params: Record<string, unknown>;
  result: unknown;
}

export interface CopilotAskResponse {
  content: string;
  toolCalls: CopilotToolCall[];
  usage?: { promptTokens?: number; completionTokens?: number; totalTokens?: number };
  conversationId: number;
}

export interface CopilotProfile {
  id: number;
  name: string;
  slug: string;
  model: string | null;
  isSystem: boolean;
}

export const copilotService = {
  async getProfile(): Promise<CopilotProfile> {
    const { data } = await api.get<ApiResponse<CopilotProfile>>('/ai/copilot/profile');
    if (!data.data) throw new Error('Studio Copilot profili alınamadı');
    return data.data;
  },

  async ask(message: string, sessionId?: string): Promise<CopilotAskResponse> {
    const { data } = await api.post<ApiResponse<CopilotAskResponse>>('/ai/copilot/ask', {
      message,
      sessionId,
    });
    if (!data.data) throw new Error('Copilot yanıtı alınamadı');
    return data.data;
  },

  async approve(correlationId: string, approved: boolean): Promise<{ ok: boolean; approved: boolean }> {
    const { data } = await api.post<ApiResponse<{ ok: boolean; approved: boolean }>>('/ai/copilot/approve', {
      correlationId,
      approved,
    });
    return data.data ?? { ok: true, approved };
  },
};
